module.exports = __webpack_public_path__ + "static/img/commitments.20918b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/commitments.png
// module id = MNzr
// module chunks = 0